import Cookies from 'js-cookie';
import CoreFirebaseAPI from '../core/CoreFirebaseAPI';
import 'firebase/firebase-database';

class FirebaseNotificationAPI {
  constructor() {
    this.api = null;
  }

  setApi(api) {
    this.api = api.getInstance();
  }

  getAPI(){
    if(!this.api) {
      const USER_ACCESS_COOKIE = 'uac';
      const { userId = 0 } = Cookies.getJSON(USER_ACCESS_COOKIE) || {};
      const url = `/settings/brokers/${userId}/notifications/menu`;
      this.setApi(new CoreFirebaseAPI(url));
    }

    return this.api;
  }

  putReadNotification(menuKey, read) {
    const payload = {
      read,
      date: new Date().toDateString()
    };
    const child = this.getAPI().child(menuKey);
    child.set(payload);
  }

  async getNotifications() {
    const response = await this.getAPI().once('value').then(snapshot => snapshot.val());
    return response;
  }
}

const api = new FirebaseNotificationAPI();

export default api;
